export const BLANK_VALUE = 'GC_BLANK_DEFAULT';
const FIRST_CHOICE = '';
const getEntryValue = (entry_value = {}) => {
  const {
    text
  } = entry_value;
  return text;
};
export const resolveValue = (value, entries) => {
  if (value === FIRST_CHOICE) {
    return getEntryValue(entries[0]);
  }
  if (value === BLANK_VALUE) {
    return null;
  }
  return value;
};
export const getValue = ({
  value,
  default: defaultValue,
  entry_values
}) => {
  const entryValue = value || defaultValue;
  return resolveValue(entryValue, entry_values);
};
const hasValue = previewEntry => !!getValue(previewEntry);
const hasRequiredValue = previewEntry => {
  // TODO: We should have a shared place to store standard error messages...
  const errorMessage = 'This field is required';
  const {
    required
  } = previewEntry;
  if (required && !hasValue(previewEntry)) {
    return errorMessage;
  }
};
export default [{
  validation: hasRequiredValue,
  type: 'required'
}];